import { sendGet, sendPut, sendPost, sendDelete, type Response } from '../../hooks/use-fetch'
import {
  type ManagementOverview,
  type ManagementDrillDown,
  type ManagementActivity,
  type ManagementBuildingRow,
  type ManagementDrillLevel,
  type ManagementStatusFilter
} from '../../models/peerToPeer/Management'
import { type ReminderResult } from '../../models/peerToPeer/Reminders'

export interface ManagementFormEdit {
  schema: string
  answers: string | null
  status: string
  submittedByName: string
  orgPath: string
}

export interface ManagementRemindRequest {
  p2pBuildingFormIds?: number[]
  districtOrganizationIds?: number[]
  reportingYearId: number
}

export async function GetManagementOverview (reportingYearId: number): Promise<Response<ManagementOverview>> {
  return await sendGet(`PeerToPeer/Management/Overview?reportingYearId=${reportingYearId}`)
}

export async function GetManagementDrillDown (level: ManagementDrillLevel, reportingYearId: number, parentOrganizationId?: number): Promise<Response<ManagementDrillDown>> {
  const parent = parentOrganizationId != null ? `&parentOrganizationId=${parentOrganizationId}` : ''
  return await sendGet(`PeerToPeer/Management/DrillDown?level=${level}&reportingYearId=${reportingYearId}${parent}`)
}

export async function GetManagementActivity (level: ManagementDrillLevel, reportingYearId: number): Promise<Response<ManagementActivity>> {
  return await sendGet(`PeerToPeer/Management/Activity?level=${level}&reportingYearId=${reportingYearId}`)
}

export async function GetManagementBuildings (districtOrganizationId: number, reportingYearId: number): Promise<Response<ManagementBuildingRow[]>> {
  return await sendGet(`PeerToPeer/Management/Buildings?districtOrganizationId=${districtOrganizationId}&reportingYearId=${reportingYearId}`)
}

export async function GetManagementStatus (filter: ManagementStatusFilter, search: string, reportingYearId: number): Promise<Response<ManagementBuildingRow[]>> {
  return await sendGet(`PeerToPeer/Management/Status?filter=${filter}&search=${encodeURIComponent(search)}&reportingYearId=${reportingYearId}`)
}

export async function GetManagementForm (p2pBuildingFormId: number): Promise<Response<ManagementFormEdit>> {
  return await sendGet(`PeerToPeer/Management/Form/${p2pBuildingFormId}`)
}

export async function CorrectManagementForm (p2pBuildingFormId: number, answersJson: string): Promise<Response<unknown>> {
  return await sendPut(`PeerToPeer/Management/Form/${p2pBuildingFormId}`, { answersJson })
}

export async function DeleteManagementForm (p2pBuildingFormId: number): Promise<Response<unknown>> {
  return await sendDelete(`PeerToPeer/Management/Form/${p2pBuildingFormId}`)
}

export async function SendManagementReminders (request: ManagementRemindRequest): Promise<Response<ReminderResult>> {
  return await sendPost('PeerToPeer/Management/Remind', request)
}
